import { Reveal } from "../MaskedLine";

const PILLARS = [
  { n: "01", title: "Built around your business", body: "Your roles, work samples and performance priorities shape the programme." },
  { n: "02", title: "Grounded in thinking and behaviour", body: "We develop the judgment, self-awareness and habits behind effective performance." },
  { n: "03", title: "Designed for application", body: "Practice, workplace assignments and manager follow-up connect learning to everyday work." },
  { n: "04", title: "Measured against agreed outcomes", body: "You know what we are trying to improve and what evidence we will collect." }
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="ground-paper sec-pad border-t border-[color:var(--line-soft)]">
      <div className="wrap">
        <p className="stamp mb-6" style={{ fontSize: 12 }}>The value proposition</p>

        <div className="grid lg:grid-cols-12 gap-x-10 gap-y-10 items-start">
          <div className="lg:col-span-6">
            <h2 className="h-section" style={{ fontSize: "clamp(30px, 3.6vw, 50px)", lineHeight: 1.06 }}>
              Training built around <span className="claim">the work you need to improve</span>.
            </h2>
            <p className="font-body-serif measure mt-6 text-[#0E1330]" style={{ fontSize: 18, lineHeight: 1.7 }}>
              A communication problem may begin with unclear thinking. A leadership problem may begin with an untested assumption. An AI mistake may begin with misplaced confidence. <span className="font-hook not-italic" style={{ fontWeight: 800 }}>We develop the thinking behind the skill.</span>
            </p>
          </div>

          <div className="lg:col-span-6">
            <Reveal>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-8">
                {PILLARS.map((p) => (
                  <li key={p.n} className="border-t border-[color:var(--ink)] pt-4">
                    <span className="stamp" style={{ fontSize: 11, color: "var(--pink)" }}>{p.n}</span>
                    <p className="font-hook mt-3" style={{ fontSize: 20, lineHeight: 1.15, letterSpacing: "-0.015em" }}>
                      {p.title}
                    </p>
                    <p className="font-body-serif mt-3 text-[#383D5A]" style={{ fontSize: 15, lineHeight: 1.6 }}>
                      {p.body}
                    </p>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
